import React, { useState, useEffect } from "react";
import { IMaster, IRecordRequest, IService } from "app/api/types";
import moment from "moment";

import "./styles.scss";
import TIMES from "app/consts/TIMES";

interface IProps {
  record: IRecordRequest;
  masterList: IMaster[];
  serviceList: IService[];
  isActive: boolean;
  onSubmit: (data: IRecordRequest) => void;
}

const AddRecordForm: React.FC<IProps> = props => {
  const [timeStart, setTimeStart] = useState(
    TIMES.indexOf(props.record.timeStart)
  );
  const [timeEnd, setTimeEnd] = useState(TIMES.indexOf(props.record.timeEnd));
  const [customerPhone, setCustomerPhone] = useState(
    props.record.customerPhone
  );
  const [customerName, setCustomerName] = useState(props.record.customerName);
  const [masterId, setMaster] = useState(props.record.masterId);
  const [date, setDate] = useState(props.record.date);
  const [serviceIds, setServices] = useState(props.record.serviceIds);

  const [selectExpanded, setSelectState] = useState(false);

  const [errorStyle, setErrorStyle] = useState({
    customerName: "",
    customerPhone: "",
    serviceIds: ""
  });

  const handleChange = (e: any) => {
    e.target.name === "timeStart" && setTimeStart(e.target.value);
    e.target.name === "timeEnd" && setTimeEnd(e.target.value);
    e.target.name === "customerName" && setCustomerName(e.target.value);
    e.target.name === "customerPhone" && setCustomerPhone(e.target.value);

    e.target.name === "masters" && setMaster(e.target.value);
    e.target.name === "date" && setDate(e.target.value);

    if (e.target.name === "timeStart") {
      setTimeEnd(e.target.value + timeEnd - timeStart);
      setTimeStart(e.target.value);
    }

    if (e.target.name === "serviceIds") {
      let currentCheckedService = props.serviceList.find(
        service => service.id === e.target.value
      );
      let additionalTime = currentCheckedService
        ? +currentCheckedService.duration / 30
        : 0;
      if (e.target.checked) {
        setServices([...serviceIds, +e.target.value]);
        setTimeEnd(timeEnd + additionalTime);
        return;
      }

      setServices(
        serviceIds.filter(serviceId => serviceId !== Number(e.target.value))
      );
      setTimeEnd(timeEnd - additionalTime);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (
      customerName.length > 1 &&
      customerPhone.length > 1 &&
      serviceIds.length > 0
    ) {
      props.onSubmit({
        id: props.record.id,
        serviceIds,
        date,
        timeStart: TIMES[timeStart],
        timeEnd: TIMES[timeEnd],
        customerName,
        customerPhone,
        masterId,
        isAccepted: props.record.isAccepted
      });
    }
  };

  useEffect(() => {
    setErrorStyle({
      customerName:
        customerName && customerName.length > 1
          ? ""
          : "edit-phrase__input_error",
      customerPhone:
        customerPhone && customerPhone.length > 1
          ? ""
          : "edit-phrase__input_error",
      serviceIds:
        serviceIds && serviceIds.length !== 0 ? "" : "edit-phrase__input_error"
    });
  }, [customerName, customerPhone, serviceIds]);

  return (
    <form
      className={`add-record__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="masters" className="edit-phrase__label">
        мастер
      </label>
      <select
        value={masterId}
        onChange={handleChange}
        name="masters"
        className="edit-phrase__input"
      >
        {props.masterList.map(master => (
          <option value={master.id} key={master.id}>
            {master.name}
          </option>
        ))}
      </select>

      <label htmlFor="customerName" className="edit-phrase__label">
        имя клиента
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.customerName}`}
        type="text"
        placeholder={customerName}
        name="customerName"
        value={customerName}
        onChange={handleChange}
        autoComplete="off"
        required
      />
      <label htmlFor="customerPhone" className="edit-phrase__label">
        телефон
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.customerPhone}`}
        type="text"
        placeholder={customerPhone}
        name="customerPhone"
        value={customerPhone}
        onChange={handleChange}
        autoComplete="off"
        required
      />

      <label htmlFor="serviceIds" className="edit-phrase__label">
        услуги
      </label>
      <div
        className={`multiselect edit-phrase__input ${errorStyle.serviceIds}`}
        onClick={() => setSelectState(!selectExpanded)}
      >
        <p>Выбрано услуг ({serviceIds.length})</p>
        <div
          className={`multiselect-container ${selectExpanded &&
            "multiselect-container_active"}
          `}
        >
          {props.serviceList.map(service => (
            <label key={service.id}>
              <input
                type="checkbox"
                name="serviceIds"
                value={service.id}
                onChange={handleChange}
                defaultChecked={
                  !!props.record.serviceIds.find(
                    id => Number(id) === Number(service.id)
                  )
                }
              />
              {service.title}
            </label>
          ))}
        </div>
      </div>

      <label htmlFor="timeStart" className="edit-phrase__label">
        время начала
      </label>
      <select
        value={timeStart}
        onChange={handleChange}
        name="timeStart"
        className="edit-phrase__input"
      >
        {TIMES.map((time, index) => (
          <option value={index} key={index}>
            {time}
          </option>
        ))}
      </select>

      <label htmlFor="timeEnd" className="edit-phrase__label">
        время конца
      </label>
      <select
        value={timeEnd}
        onChange={handleChange}
        name="timeEnd"
        className="edit-phrase__input"
      >
        {TIMES.map((time, index) => (
          <option value={index} key={index}>
            {time}
          </option>
        ))}
      </select>

      <label htmlFor="date" className="edit-phrase__label">
        дата
      </label>
      <input
        className="edit-phrase__input"
        name="date"
        type="date"
        defaultValue={moment(props.record.date).format("YYYY-MM-DD")}
        onChange={handleChange}
      />

      <button
        type="submit"
        className="edit-phrase__submit"
        onClick={handleSubmit}
      >
        создать
      </button>
    </form>
  );
};

export default AddRecordForm;
